/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';

import { decodeToken, getToken } from '../utils/TokenUtils';

import { CURRENT_DATE, FIRST_DAY_OF_MONTH } from '../constants';

import BlankHorizontalForm from './BlankHorizontalForm';
import DataModal from './DataModal';
import { useNavigate } from 'react-router-dom';
const TopNavbarStatement = () => {
  const token = getToken();
  //console.log('token:', token);

  const top_navbar_statement_link_id = decodeToken(
    token,
    'top_navbar_statement_link_id'
  );

  const [loading, setLoading] = useState(false);

  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [data, setData] = useState([]);

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);

  const userId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');
  const navigate = useNavigate(); // Hook to navigate to other routes

  // Fetch data from the server when the query changes
  useEffect(() => {
    if (!token) {
      // console.log('no token redirected');
      navigate('/login/user-login');
    }
    // console.log('there is token and not redirected');
    let response;
    //console.log(token);
    const url = `${API_URL}/${ENDPOINTS.SYS}/get-top-navbar-statement/${top_navbar_statement_link_id}`;
    //console.log(url);
    const fetchData = async () => {
      setLoading(true);

      try {
        response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        // console.log(response.data);
        setLink(response.data.link[0]);
        setInputs(response.data.inputs);

        //console.log('response.data:', response.data);
        const initialState = {};

        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load-dropdown' ||
            input.type === 'enum-dropdown' ||
            input.type === 'group-dropdown'
          ) {
            // You can determine the selected value from the data
            const selectedOption = input?.dynamic_options?.find(
              (option) => option.selected === 'selected'
            );
            if (selectedOption) {
              initialState[input.name] = selectedOption.value;
            } else {
              initialState[input.name] = '%';
            }
          } else if (
            input.type === 'date' &&
            input.name === 'from' &&
            input.value === 'first_day_of_month'
          ) {
            initialState[input.name] = FIRST_DAY_OF_MONTH;
          } else if (input.type === 'date' && input.name === 'to') {
            initialState[input.name] = CURRENT_DATE;
          } else if (input.type === 'hidden-user') {
            initialState[input.name] = userId;
          } else if (input.type === 'hidden-branch') {
            initialState[input.name] = branchId;
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        setValues(initialState);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // console.log('Unauthorized: Token is invalid or expired.');
          navigate('/login/user-login');
        } else {
          console.log('Error fetching data:', error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // console.log('data:', data);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="d-flex  align-items-center gap-2">
      {data && data.length > 0 && (
        <DataModal
          title={'Statement'}
          data={data}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}

      <BlankHorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setInputs={setInputs}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setData={setData}
        setValues={setValues}
        setIsModalOpen={setIsModalOpen}
      />

      {(API_URL.includes('jaziiraapi') || API_URL.includes('jappapi')) && (
        <>
          <button
            className="btn btn-info"
            style={{ marginBottom: '10px' }}
            onClick={() => navigate(`/pos`)}
          >
            Make Order
          </button>
          <button
            className="btn btn-info"
            style={{ marginBottom: '10px' }}
            onClick={() => navigate(`/pos/pending-orders`)}
          >
            Pending Orders
          </button>
        </>
      )}
    </div>
  );
};

export default TopNavbarStatement;
